import one from '../assets/svg/projects/one.svg'
import img from '../assets/svg/projects/img.png'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import quran from '../assets/svg/projects/quran.jpg'
import therapy from '../assets/svg/projects/therapy.jpg'

import devoperate from "../assets/svg/projects/devoperate.png"
import optahire from "../assets/svg/projects/optahire.png"
import ultralap from "../assets/svg/projects/ultralap.jfif"

export const projectsData = [
  {
    id: 1,
    projectName: "DevOperate",
    projectDesc:
      "Official website of DevOperate showcasing AI solutions, software development, SaaS, cloud services, automation, and digital transformation for businesses worldwide.",
    tags: ["Next JS", "React", "Tailwind", "Typescript"],
    code: "https://devoperate.com",
    demo: "https://devoperate.com",
    image: devoperate,
  },
{
    id: 2,
    projectName: "AI Healthcare System (Final Year Project)",
    projectDesc:
      "An AI-powered healthcare platform featuring disease prediction, intelligent chatbot, appointment scheduling, and medical assistance using machine learning.",
    tags: ["React", "Node JS", "Python", "MongoDB"],
    code: "https://github.com/abubakar003m/Final-Year-Project.git",
    demo: "https://github.com/abubakar003m/Final-Year-Project.git",
    image: one,
  },
  {
    id: 3,
    projectName: "Opta Hire (AI Recruitment Platform)",
    projectDesc:
      "An AI-powered recruitment platform that automates resume screening, candidate matching, interview management, and hiring workflows.",
    tags: ["React", "Node JS", "PostgreSQL", "AI"],
    code: "https://opta-hire-fyp-app-client.vercel.app/",
    demo: "https://opta-hire-fyp-app-client.vercel.app/",
    image: optahire,
  },

  {
    id: 4,
    projectName: "Psychological Mind Centre",
    projectDesc:
      "Professional healthcare website developed for a UK-based psychological clinic with a modern, responsive, and user-friendly interface.",
    tags: ["Next JS", "React", "Tailwind"],
    code: "https://psychologicalmindcentre.co.uk/",
    demo: "https://psychologicalmindcentre.co.uk/",
    image: therapy,
  },

  {
    id: 5,
    projectName: "UltraLap E-Commerce",
    projectDesc:
      "A complete e-commerce platform featuring product management, shopping cart, secure checkout, and responsive user experience.",
    tags: ["React", "Node JS", "MongoDB"],
    code: "https://ultralap.pk/",
    demo: "https://ultralap.pk/",
    image: ultralap,
  },

  {
    id: 6,
    projectName: "Digital Scrap",
    projectDesc:
      "A smart scrap management platform that allows users to schedule scrap pickups, sell recyclable materials, and manage collections efficiently.",
    tags: ["React", "Node JS", "MongoDB"],
    code: "https://www.digitalscrappk.com/",
    demo: "https://www.digitalscrappk.com/",
    image: img,
  },

  
]

// export const projectsData = [
//     {
//         id: 1,
//         projectName: 'Digital Scrap',
//         projectDesc: 'Digital Scrap is a application that revolutionizes scrap collection. It allows users to list scrap materials for pickup, schedule pickups, and trade scrap materials through a user-friendly platform.',
//         tags: ['React', 'CSS', 'Node JS','MongoDB'],
//         code: 'https://www.digitalscrappk.com/',
//         demo: 'https://www.digitalscrappk.com/',
//         image: img
//     },
//     {
//         id: 2,
//         projectName: 'E-Commerce Dashboard',
//         projectDesc: 'This project aims to build an simple e-commerce website that consolidates all information of a company',
//         tags: ['React', 'CSS', 'Node JS','MongoDB'],
//         code: 'https://github.com/abubakar003m/e-commerce_dashboard',
//         demo: 'https://github.com/abubakar003m/e-commerce_dashboard',
//         image: one
//     },
//     {
//         id: 3,
//         projectName: 'Mind Wave Therepy',
//         projectDesc: 'This project is Empowering your path to mental well-being through personalized, evidence-based therapy.',
//         tags: ['React', 'CSS','Material Ui'],
//         code: 'https://mindwavetherapy.co.uk/',
//         demo: 'https://mindwavetherapy.co.uk/',
//         image: therapy
//     },
//     {
//         id: 4,
//         projectName: 'Food App',
//         projectDesc: 'This project is a Food App that allows users to Order Food.',
//         tags: ['React', 'CSS','Material Ui'],
//         code: 'https://github.com/abubakar003m/food-app',
//         demo: 'https://muhammad-abubakar.netlify.app/',
//         image: five
//     },
  
//     {
//         id: 5,
//         projectName: 'AR Rehman Islamic Center',
//         projectDesc: 'AR-Rehman Islamic Center is a distinguished online platform that offers a variety of live classes to assist individuals in learning the Quran online',
//         tags: ['HTML', 'CSS','JS'],
//         code: 'https://arrahmanislamiccentre.com/',
//         demo: 'https://arrahmanislamiccentre.com/',
//         image: quran
//     },
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
// ]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/